import { render, staticRenderFns } from "./ExplainRecord.vue?vue&type=template&id=3c7e6c26&scoped=true&"
import script from "./ExplainRecord.vue?vue&type=script&lang=js&"
export * from "./ExplainRecord.vue?vue&type=script&lang=js&"
import style0 from "./ExplainRecord.vue?vue&type=style&index=0&id=3c7e6c26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7e6c26",
  null
  
)

export default component.exports